/**
 * siteIcon.js — Best-effort favicon URL for any external site.
 *
 * Uses Google's public S2 favicon service which returns a high-res
 * icon for the given domain (~99% of real websites resolve). Falls
 * back to '' when the URL can't be parsed so the caller can decide
 * whether to render a generic ExternalLink glyph instead.
 */
export const siteIconUrl = (url, size = 128) => {
  if (!url) return '';
  try {
    const u = new URL(url.startsWith('http') ? url : `https://${url}`);
    return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(u.hostname)}&sz=${size}`;
  } catch {
    return '';
  }
};

/**
 * initialsFor — Two-letter uppercase initials for a display name.
 * Used everywhere we want a text avatar fallback when a photo is
 * missing / fails to load.
 */
export const initialsFor = (name) => {
  const t = (name || '').trim();
  if (!t) return '?';
  const parts = t.split(/\s+/).filter(Boolean);
  const chars = parts.length >= 2
    ? [parts[0][0], parts[parts.length - 1][0]]
    : [parts[0][0], parts[0][1] || ''];
  return chars.join('').toUpperCase();
};
